import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";

import {GameCenterWidgetConfig} from "./game-center-widget.config";
import {GameCenterWidgetStore} from "./game-center-widget.store";
import {GameCenterWidgetHandlers} from "./handlers/game-center-widget.handlers";
import {FullGameResponseDomainService} from "../../domain/full-game/services/full-game-response.domain-service";

export class GameCenterWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables,  GameCenterWidgetConfig, GameCenterWidgetStore, GameCenterWidgetHandlers, FullGameResponseDomainService];

}
